module.exports = __webpack_public_path__ + "static/media/bypass.f58989d1.png";